import { render, staticRenderFns } from "./homeContents.vue?vue&type=template&id=3fb21b66&scoped=true&"
import script from "./homeContents.vue?vue&type=script&lang=js&"
export * from "./homeContents.vue?vue&type=script&lang=js&"
import style0 from "./homeContents.vue?vue&type=style&index=0&id=3fb21b66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb21b66",
  null
  
)

component.options.__file = "homeContents.vue"
export default component.exports